module.exports = __webpack_public_path__ + "static/media/illustrator.44ca6901.png";